/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type CustomerSignup_AddUserMutationVariables = {
    firstName: string;
    lastName: string;
    email: string;
    password: string;
    country: string;
};
export type CustomerSignup_AddUserMutationResponse = {
    readonly addUser: boolean;
};
export type CustomerSignup_AddUserMutation = {
    readonly response: CustomerSignup_AddUserMutationResponse;
    readonly variables: CustomerSignup_AddUserMutationVariables;
};



/*
mutation CustomerSignup_AddUserMutation(
  $firstName: String!
  $lastName: String!
  $email: String!
  $password: String!
  $country: String!
) {
  addUser(input: {firstname: $firstName, lastname: $lastName, email: $email, password: $password, country: $country})
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "country"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "email"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "firstName"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "lastName"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "password"
},
v5 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "country",
            "variableName": "country"
          },
          {
            "kind": "Variable",
            "name": "email",
            "variableName": "email"
          },
          {
            "kind": "Variable",
            "name": "firstname",
            "variableName": "firstName"
          },
          {
            "kind": "Variable",
            "name": "lastname",
            "variableName": "lastName"
          },
          {
            "kind": "Variable",
            "name": "password",
            "variableName": "password"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "kind": "ScalarField",
    "name": "addUser",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CustomerSignup_AddUserMutation",
    "selections": (v5/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v4/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "CustomerSignup_AddUserMutation",
    "selections": (v5/*: any*/)
  },
  "params": {
    "cacheID": "7b62b450dec5699c7429502b1bda7b78",
    "id": null,
    "metadata": {},
    "name": "CustomerSignup_AddUserMutation",
    "operationKind": "mutation",
    "text": "mutation CustomerSignup_AddUserMutation(\n  $firstName: String!\n  $lastName: String!\n  $email: String!\n  $password: String!\n  $country: String!\n) {\n  addUser(input: {firstname: $firstName, lastname: $lastName, email: $email, password: $password, country: $country})\n}\n"
  }
};
})();
(node as any).hash = 'edd446210b88e163b6a5e36270571db3';
export default node;
